import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { TipoCantierePort } from './tipo-cantiere.port';
import {
  TipologiaCantiere,
  CreateTipologiaCantiereDto,
  TipologiaCantierePage,
} from '../../models/tipo-cantiere.model';
import {TenantService} from '../tenant.service';

@Injectable({ providedIn: 'root' })
export class TipoCantiereHttpService implements TipoCantierePort {
  private http = inject(HttpClient);
  private tenantService = inject(TenantService);
  private base = `${environment.apiBaseUrl}/${this.tenantService.tenant}/tipologieCantieri`;

  getList(params?: { size?: number; offset?: number; tipoSearch?: string }): Observable<TipologiaCantierePage> {
    return this.http.get<TipologiaCantierePage>(this.base, { params: params as any });
  }

  create(dto: CreateTipologiaCantiereDto): Observable<number> {
    return this.http.post<number>(this.base, dto);
  }
}
